/**
 * For the user's settings that are stored on the client.
 */
import cloneDeep from 'lodash/cloneDeep';
const LOCAL_STORAGE_KEY = 'TRIPLEJACK_SETTINGS';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ALL_USER_CLIENT_SETTING_KEYS = ['SOUND_VOLUME', 'LAST_NEWS_ITEM_HASH', 'PANEL_POSITION'];
export const DEFAULT_USER_CLIENT_SETTINGS = {
    SOUND_VOLUME: {
        percent: 100
    },
    LAST_NEWS_ITEM_HASH: {
        value: undefined
    },
    PANEL_POSITION: {
        position: 'auto'
    }
};
function loadAllUserClientSettings() {
    try {
        return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');
    }
    catch {
        // parse error, delete the whole thing if localStorage is available:
        if (localStorage && localStorage.removeItem) {
            // The error "Cannot read property 'removeItem' of null" has been observed, so check for localStorage before removing:
            localStorage.removeItem(LOCAL_STORAGE_KEY);
        }
        return {};
    }
}
/**
 * Exported for unit tests.
 */
export function loadUserClientSettings(playerId) {
    const allUserClientSettings = loadAllUserClientSettings();
    const userClientSettings = allUserClientSettings[`${playerId}`];
    if (!userClientSettings) {
        return cloneDeep(DEFAULT_USER_CLIENT_SETTINGS);
    }
    // fill in any blanks with defaults:
    Object.keys(DEFAULT_USER_CLIENT_SETTINGS).forEach((settingKey) => {
        if (!userClientSettings[settingKey]) {
            userClientSettings[settingKey] = cloneDeep(DEFAULT_USER_CLIENT_SETTINGS[settingKey]
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            );
        }
    });
    return userClientSettings;
}
export function saveUserClientSetting(playerId, settingKey, settingValue) {
    const allUserClientSettings = loadAllUserClientSettings();
    const userClientSettings = allUserClientSettings[`${playerId}`] || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    userClientSettings[settingKey] = settingValue;
    // set entire user object back (in case it was initialized anew):
    allUserClientSettings[`${playerId}`] = userClientSettings;
    if (localStorage && localStorage.setItem) {
        // I think the presence of localStorage is not guaranteed.
        localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(allUserClientSettings));
    }
}
